import React from 'react';
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite';
import classNames from 'classnames';

const STYLES = StyleSheet.create({
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},

	dropdown: {
		height: 42,
		padding: 0,
		textIndent: 10,
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none',
		'@-moz-document url-prefix()': {
			textIndent: 2.5
		},
		'::-ms-expand': { display: 'none' },
	},

	arrow: {
		position: 'absolute',
		right: 10,
		top: 20,
		cursor: 'default',
		pointerEvents: 'none'
	},

	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
})

class PhoneCountryCode extends React.Component {
	constructor(props) {
		super()
		const { defaultNumber: { countryCode } = {} } = props
		this.state = {
			countryCode: countryCode,
			phoneTypeErrorMessage: '',
			showIsRequiredError: false
		};
	}

	handleChange = (event) => {
		let value = event.target.value
		this.setState({ countryCode: value })
		this.props.changeCountryCode(value)
		return value
	}

	render() {

		const { errorMessage, label, supportedCountries } = this.props
		let { countryCodeErrorMessage } = this.state
		let errorMessageClassNames = classNames(css(STYLES.errorMessage), {
			'vx_form-control-message': errorMessage || countryCodeErrorMessage
		})
		let errorStyles = {
			height: 0,
			padding: 0
		}
		if (errorMessage || countryCodeErrorMessage) {
			errorStyles = { height: '100%' }
		}

		return (
			<div className={classNames({
				'vx_has-error-with-message': errorMessage,
				'vx_has-error': errorMessage,
			})} style={{ margin: '0 0 10px 0', position: 'relative' }}>
				<div style={{ position: 'relative' }}>
					<select id="phoneCountryCode"
						className={`vx_form-control vx_form-control_complex ${css(STYLES.dropdown)}`}
						value={this.state.countryCode}
						onChange={this.handleChange}>
							<option value="" disabled>{label}</option>
							{supportedCountries.map((item) => (
								<option key={item.countryCode} value={item.phoneCode}>{item.phoneCode} ({item.countryCode})</option>
							))}
					</select>
					<label htmlFor="phoneCountryCode" className={`icon icon-arrow-down-small ${css(STYLES.arrow)}`}></label>
					<div className={errorMessageClassNames} style={errorStyles}>{errorMessage || countryCodeErrorMessage}</div>
				</div>
			</div>
		)
	}
}

PhoneCountryCode.propTypes = {
	changeCountryCode: PropTypes.func.isRequired,
	errorMessage: PropTypes.string,
	guestLabels: PropTypes.object,
	label: PropTypes.string,
	supportedCountries: PropTypes.array
}

export default PhoneCountryCode



// WEBPACK FOOTER //
// ./components/phone-country-code.js